// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JR1a","left":"styles_left__3GjQT"};